import { Box, Button, Image, Input, Text } from "@chakra-ui/react";
import { theme } from "../../styles/theme";
import { api } from "../../services/api";
import Logo from "../../assets/images/logo.svg";
import { useState } from "react";
import { useAuth } from "../../Hooks/useAuth";
import swal  from 'sweetalert';

export function EditPassword() {
  const { user, signInUser } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");

  async function handlePasswordResetForUser(e) {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search)
    const resetPasswordToken = params.get("reset_password_token")
    const data = {
      user: {
        reset_password_token: resetPasswordToken,
        password: newPassword,
        password_confirmation: newPasswordConfirmation
      }
    };

    try {
      const response = await api.put(`/users/password`, data);

      if (response.data.success) {
        signInUser(response.data.user.email, newPassword, response.data.user.id)
        swal({
          title: "Ok",
          text: "Senha trocada com sucesso!!",
          icon: "success",
        });
      } else {
        swal({
          title: "Oh nooo",
          text: "Algo deu errado!!",
          icon: "error",
        });
      }
    } catch (error) {
      console.error('Error occurred while making the password reset request:', error);
    }
  }

  return (
    <Box
      minH="100vh"
      bg="#f8f8f8"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={{ base: 4, md: 8 }}
    >
      <Box
        maxW="1100px"
        w="100%"
        bg="white"
        borderRadius="24px"
        overflow="hidden"
        boxShadow="0 12px 40px rgba(0,0,0,.08)"
      >
        <Box
          display="flex"
          flexDirection={{ base: "column", lg: "row" }}
        >
          {/* LADO ESQUERDO */}
          <Box
            flex="1"
            bg="linear-gradient(135deg,#004a33,#006b4b)"
            color="white"
            p={{ md: 12 }}
            display={{ base: "none", lg: "flex" }}
            flexDirection="column"
            justifyContent="center"
          >
            <Image
              src={Logo}
              maxW="220px"
              mb="10"
              objectFit="contain"
              filter="brightness(0) invert(1)"
            />

            <Text
              fontSize="48px"
              fontWeight="900"
              lineHeight="1.1"
            >
              Redefinir
              <br />
              Senha
            </Text>

            <Text
              mt="6"
              opacity=".9"
              fontSize="18px"
              maxW="500px"
            >
              Escolha uma nova senha para continuar
              utilizando sua conta com segurança.
            </Text>

            <Box mt="10">
              <Text mb="3">
                ✓ Ambiente Seguro
              </Text>

              <Text mb="3">
                ✓ Dados Protegidos
              </Text>

              <Text mb="3">
                ✓ Criptografia de Senhas
              </Text>

              <Text>
                ✓ Acesso Imediato Após Alteração
              </Text>
            </Box>
          </Box>

          {/* LADO DIREITO */}
          <Box
            flex="1"
            p={{ base: 6, md: 12 }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <Image
              src={Logo}
              maxW="180px"
              mx="auto"
              mb="8"
              display={{ base: "block", lg: "none" }}
            />

            <Text
              fontSize={{ base: "32px", md: "40px" }}
              fontWeight="900"
              color="#004a33"
            >
              Nova Senha
            </Text>

            <Text
              color="gray.500"
              mt="2"
              mb="8"
            >
              Informe e confirme sua nova senha.
            </Text>

            <Input
              id="password-input"
              placeholder="Nova senha"
              type="password"
              h="56px"
              mb="4"
              borderRadius="14px"
              onChange={(e) => setNewPassword(e.target.value)}
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            <Input
              id="password-input-confirmation"
              placeholder="Confirmar nova senha"
              type="password"
              h="56px"
              borderRadius="14px"
              onChange={(e) =>
                setNewPasswordConfirmation(e.target.value)
              }
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            <Button
              mt="8"
              h="56px"
              w="100%"
              bg="#fc8f04"
              color="white"
              borderRadius="14px"
              fontWeight="700"
              _hover={{
                bg: "#ea8100"
              }}
              onClick={(e) => handlePasswordResetForUser(e)}
            >
              Alterar Senha
            </Button>

            <Box
              mt="10"
              pt="6"
              borderTop="1px solid"
              borderColor="gray.100"
            >
              <Text
                fontSize="13px"
                color="gray.500"
                textAlign="center"
              >
                Após redefinir sua senha você será autenticado
                automaticamente em sua conta.
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
